<template>
  <div v-if="tenant.subdomain === '#pfx'">
    <FrontPagePfx />
  </div>
  <div v-else>
    <FrontPageTenant />
  </div>
</template>

<script>
  import FrontPagePfx from './FrontPagePfx.vue'
  import FrontPageTenant from './FrontPageTenant.vue'

  export default {
    name: 'FrontPage',
    components: {
      FrontPagePfx,
      FrontPageTenant
    },
    data() {
      return {
        tenant: this.$store.state.tenant
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/FrontPage.vue